import {useEffect, useState} from "react";

import {useEmailVerificationApiError} from "@pg-rp/email-with-verification";

import {useVerifyEmailQuery} from "../api/email_verification_api";

interface IUseEmailVerificationGateParams {
    currentEmail: string;
    setFieldError: (message: string | undefined) => void;
    bypassEmail?: string;
}

/** E-mail addresses are matched the way the sign up treats them: without surrounding whitespace and regardless of letter case */
const isSameEmail = (first: string | null | undefined, second: string | null | undefined) =>
    Boolean(first) && Boolean(second) && first?.trim().toLowerCase() === second?.trim().toLowerCase();

export const useEmailVerificationGate = (params: IUseEmailVerificationGateParams) => {
    const {currentEmail, setFieldError, bypassEmail} = params;
    const [verifiedEmail, setVerifiedEmail] = useState<string | null>(null);
    const {data: verificationData, error: verificationError, isFetching} = useVerifyEmailQuery({email: verifiedEmail || ""}, {skip: !verifiedEmail});
    const verificationApiError = useEmailVerificationApiError({errorData: verificationError});

    const isBypassEmail = isSameEmail(currentEmail, bypassEmail);
    const isEmailChecked = isSameEmail(currentEmail, verifiedEmail);
    const isVerificationUnavailable = isEmailChecked && Boolean(verificationError) && verificationApiError.isValid;
    const isEmailVerified = isBypassEmail || isVerificationUnavailable || (isEmailChecked && verificationData?.valid === true);

    useEffect(() => {
        if (!verificationApiError.isValid) {
            setFieldError(verificationApiError.message);
        }
    }, [verificationApiError]);

    return {verificationTrigger: setVerifiedEmail, verificationData, isChecking: isFetching, isEmailVerified};
};
import {useEffect, useState} from "react";

import {useEmailVerificationApiError} from "@pg-rp/email-with-verification";

import {useVerifyEmailQuery} from "../api/email_verification_api";

interface IUseEmailVerificationGateParams {
    currentEmail: string;
    setFieldError: (message: string | undefined) => void;
    bypassEmail?: string;
}

/** E-mail addresses are matched the way the sign up treats them: without surrounding whitespace and regardless of letter case */
const isSameEmail = (first: string | null | undefined, second: string | null | undefined) =>
    Boolean(first) && Boolean(second) && first?.trim().toLowerCase() === second?.trim().toLowerCase();

export const useEmailVerificationGate = (params: IUseEmailVerificationGateParams) => {
    const {currentEmail, setFieldError, bypassEmail} = params;
    const [verifiedEmail, setVerifiedEmail] = useState<string | null>(null);
    const {data: verificationData, error: verificationError, isFetching} = useVerifyEmailQuery({email: verifiedEmail || ""}, {skip: !verifiedEmail});
    const verificationApiError = useEmailVerificationApiError({errorData: verificationError});

    const isBypassEmail = isSameEmail(currentEmail, bypassEmail);
    const isEmailChecked = isSameEmail(currentEmail, verifiedEmail);
    const isVerificationUnavailable = isEmailChecked && Boolean(verificationError) && verificationApiError.isValid;
    const isEmailVerified = isBypassEmail || isVerificationUnavailable || (isEmailChecked && verificationData?.valid === true);

    useEffect(() => {
        if (!verificationApiError.isValid) {
            setFieldError(verificationApiError.message);
        }
    }, [verificationApiError]);

    return {verificationTrigger: setVerifiedEmail, verificationData, isChecking: isFetching, isEmailVerified};
};
